{
  "version": 1,
  "asset_id": "1caa2a5b-1d01-48e2-aa2b-df4ddbee107c",
  "project_id": "1203040e-940d-4f2e-ab5b-8733ed2d3c31",
  "url": "/__l5e/assets-v1/1caa2a5b-1d01-48e2-aa2b-df4ddbee107c/opt_metodo-formato.jpg",
  "r2_key": "a/v1/1203040e-940d-4f2e-ab5b-8733ed2d3c31/1caa2a5b-1d01-48e2-aa2b-df4ddbee107c/opt_metodo-formato.jpg",
  "original_filename": "opt_metodo-formato.jpg",
  "size": 95342,
  "content_type": "image/jpeg",
  "created_at": "2026-08-26T20:33:51Z"
}
